<template>
  <v-footer dark height="auto" :inset="footer.inset" app>
    <span class="px-3">&copy; {{ new Date().getFullYear() }}</span>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer.vue',
  data: () => ({
    footer: {
      inset: false
    }
  }),
  methods: {},
  computed: {
    signedIn() {
      return this.$store.state.signedIn
    },
    user() {
      return this.$store.getters.user
    }
  }
}
</script>

<style scoped></style>
